exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "input[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #007bff;\n    color: white;\n    background: #007bff;\n    border-radius: 0.25rem;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n}\n\n/* for md */\n\n.custom-switch.custom-switch-md .custom-control-label {\n    padding-left: 2rem;\n    padding-bottom: 1.5rem;\n}\n\n.custom-switch.custom-switch-md .custom-control-label::before {\n    height: 1.5rem;\n    width: calc(2rem + 0.75rem);\n    border-radius: 3rem;\n}\n\n.custom-switch.custom-switch-md .custom-control-label::after {\n    width: calc(1.5rem - 4px);\n    height: calc(1.5rem - 4px);\n    border-radius: calc(2rem - (1.5rem / 2));\n}\n\n.custom-switch.custom-switch-md .custom-control-input:checked ~ .custom-control-label::after {\n    transform: translateX(calc(1.5rem - 0.25rem));\n}\n\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/admin-settings-form/admin-settings-form.component.css
// module id = 383
// module chunks = 0